import xss from 'xss';

const XSS_WHITELIST = {
    b: [],
    br: [],
    code: [],
    div: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    li: [],
    ol: [],
    p: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    ul: [],
    u: [],
    em: [],
};

const XSS_STRIP = ['script', 'a'];

const removeDuplicatedBreakLines = (text: string) => {
    const regex = /<br><br>(<br>)+/g;
    const replaceTo = '<br><br>';

    return text.replace(regex, replaceTo);
};

export const sanitize = (text: string, whiteList = XSS_WHITELIST) => {
    if (!text) {
        return '';
    }

    return xss(removeDuplicatedBreakLines(text), {
        whiteList,
        stripIgnoreTag: true,
        stripIgnoreTagBody: XSS_STRIP,
    });
};
